import 'react-responsive-carousel/lib/styles/carousel.min.css';


import { Box } from '@mui/material';
import images from '../../../../../data/images.json';
import { Carousel } from 'react-responsive-carousel';

export default function MobileHomePage(){
    const imageList = images.home;
    return(
        <Box>
            <Carousel
                swipeable
                emulateTouch
                interval={5000}
                showStatus={false}
                showThumbs={false}
                showIndicators={false}
                autoPlay
                infiniteLoop
            >
                {imageList.map((image,i)=>(
                    <div 
                        id={`FYKIFYKI_IMG_${i}`}
                        style={{
                            height:'100vh',
                            width:'100vw',
                            overflow:'hidden'
                        }}
                    >
                    <img 
                        src={image.src} 
                        alt={image.alt} 
                        style={{
                                height: '100%',
                                width: '100%',
                                objectFit: 'cover',
                                objectPosition: 'center',
                                display: 'block'
                            }} 
                    />
                    </div>
                ))}
            </Carousel>
        </Box>)
}